
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"1em","height":"1em","viewBox":"0 0 48 48","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('g',{attrs:{"fill-rule":"nonzero","stroke":"#6F6F6F"}},[_c('path',{attrs:{"d":"M21.5 18.35v7.15h3v-7.15c-.674-.234-1.18-.35-1.5-.35-.32 0-.826.116-1.5.35z"}}),_c('path',{attrs:{"d":"M23 10c1.333 2.25 2 3.75 2 4.5s-.667 1.25-2 1.5c-1.333-.25-2-.75-2-1.5s.667-2.25 2-4.5z","fill":"#E2F8F8"}})]),_c('rect',{attrs:{"fill":"#CDCDCD","fill-rule":"nonzero","x":"13","y":"25","width":"20","height":"15","rx":"4"}}),_c('path',{attrs:{"d":"M11 37h23.997a1 1 0 01.968 1.25l-.515 2a1 1 0 01-.969.75H11.344a1 1 0 01-.986-.83l-.343-2A1 1 0 0111 37z","fill":"#F1F1F1","fill-rule":"nonzero"}}),_c('path',{attrs:{"d":"M13.003 29.25c.068.283 1.276-1.5 2.551 0 .85 1 1.595 1 2.233 0 1.063-.667 1.807-.667 2.232 0 .425.667 1.17.667 2.232 0 .85-.667 1.595-.5 2.233.5.637 1 1.275.833 1.913-.5.636-.667 1.272-.833 1.91-.5.957.5.957 2 1.598 1 .641-1 1.275-1 1.594-.5.32.5 1.276.5 1.592 0 .315-.5 0-3.5-1.276-4-.85-.333-6.59-.333-17.217 0-.479.29-.797.623-.957 1-.491 1.162-.668 2.873-.638 3z","stroke":"#6873B2","fill":"#6873B2","fill-rule":"nonzero"}}),_c('path',{attrs:{"d":"M23 18.5v-4","stroke":"#6F6F6F","stroke-width":".5"}})])])
          )
        }
      }
    